// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"36b96ec8","488":"6cf3bd8d","977":"83aac2ce"}[chunkId] + ".chunk.js";
};